<template>
  <div class="tabbar-item" @click="itemClick">
    <div class="item-text">
      <slot name="item-text"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BarItem",
  props: {
    path: String,
    scrolled: Boolean
  },
  methods: {
    itemClick() {
      this.$router.push(this.path)
    },
  },
}

</script>

<style>
.tabbar-item {
  flex: 1;
  color: #ffffff;
  justify-content: center; 
  position: relative;
  cursor: pointer;
  display: flex;
}

.tabbar-item span {
  letter-spacing: 0;
  font-size: 1.55rem;
}

.tabbar-item::after {
  content: '';
  width: 0;
  height: 3px;
  background-color: #018fd7;
  display: block;
  position: absolute;
  bottom: -15px;
  transition: width .3s;
}

.tabbar-item:hover:after {
  width: 70%;
}

@media (max-width: 767px) {
  .tabbar-item {
    padding: 8px; /* 减少内边距 */
  }

  .tabbar-item span {
    font-size: 1rem; /* 减少字体大小 */
  }

  .tabbar-item::after {
    content: '';
    width: 0;
    height: 2px; /* 减少下划线的高度 */
    background-color: #018fd7;
    display: block;
    position: absolute;
    bottom: 2px; /* 调整下划线的位置 */
    transition: width .3s;
  }

  .tabbar-item:hover:after {
    width: 20%; /* 减少下划线的宽度 */
  }

  .tabbar-item {
  color: #f9f9f9;
}
}
</style>


// WEBPACK FOOTER //
// src/components/tabbar/BarItem.vue